import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppServiceService } from 'src/app/api/app-service.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AlertController } from '@ionic/angular';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { RequestService } from 'src/app/core/request.service';

declare var config: any;

@Component({
  selector: 'app-subscription-summery',
  templateUrl: './subscription-summery.page.html',
  styleUrls: ['./subscription-summery.page.scss'],
})
export class SubscriptionSummeryPage implements OnInit {
  @Input() webUniqueId: string = '';
  @Output() onPaymentCancel: EventEmitter<any> = new EventEmitter();

  public subscription_id: any = '';
  public subscriptionInfo: any;
  public order_schedule_type: string = '';
  public order_days: any;
  public orderInfo: any;
  public is_end_date: boolean = false;
  public status: string = 'false';
  public end_date: string = '';
  public start_date: string = '';
  public payment_type: string = '';
  public lang: any = null;
  public payment_status: string = '';
  public totalTaxAmount = 0;
  public order_type = '';

  public translateInProgress: boolean = false;

  constructor(public appService: AppServiceService, public RequestService: RequestService, private iab: InAppBrowser, private route: ActivatedRoute, private datePipe: DatePipe, private router: Router, public translate: TranslateService, public alertController: AlertController) {
    setTimeout(() => {
      this.appService.appObject.isLoading = true;
    }, 10);


    this.route.params.subscribe((param) => {
      // console.log('param',param);
      this.subscription_id = param.subscription_id;
    });

  }

  ngOnInit() {
    // web version id passes
    if (this.appService.isWebVersion) this.subscription_id = this.webUniqueId;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.appService.appObject.isLoading = true;
    }, 10);
    setTimeout(() => {
      this.getSubscriptionDetails();
    }, 500);
  }
  async getSubscriptionDetails() {
    this.appService.getSubscriptionInfo(this.subscription_id).then(response => {
      if (response.status) {
        this.subscriptionInfo = response.data;
        this.order_schedule_type = response.data.order_schedule_type;
        this.order_days = response.data.order_days;
        this.orderInfo = response.data.order_deatails;
        this.is_end_date = response.data.is_end_date;
        this.end_date = response.data.end_date;
        this.start_date = response.data.start_date;
        this.payment_type = response.data.payment_type;
        this.order_type = response.data.order_type;
        this.status = response.data.status;
        this.payment_status = response.data.payment_status;
        // console.log(this.orderInfo);// get total tax amount to display instead of tax type
        this.totalTaxAmount = ((this.orderInfo.cart_summery.total_tax_inclusive ? this.orderInfo.cart_summery.total_tax_inclusive : 0) + (this.orderInfo.total_tax_exclusive ? this.orderInfo.total_tax_exclusive : 0));

        this.translateOrderDaysObject();
      }
      this.appService.appObject.isLoading = false;
    }, error => {
      this.appService.appObject.isLoading = false;
    });
  }

  /**
   * 
   * get languages
   */
  async getLang() {
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }

  /**
   * Translate subscription order days to readble day name
   */
  translateOrderDaysObject() {
    this.translateInProgress = true;
    let languageInt = setInterval(async () => {
      this.getLang();
      if (this.lang && this.lang !== 'key') {
        var days = '';
        for (let i = 0; i < this.order_days.length; i++) {
          days = days === '' ? this.lang[this.order_days[i]] : days + ', ' + this.lang[this.order_days[i]];
        }
        this.order_days = days;
        this.translateInProgress = false;
        clearInterval(languageInt);
      }
    }, 1000);
  }

  setDays(order_days) {
    var days = '';
    if (this.lang) {
      for (let i = 0; i < order_days.length; i++) {
        days = days === '' ? this.lang[order_days[i]] : days + ', ' + this.lang[order_days[i]];

        // Isuruge GOn CODE
        // if (order_days[i] == 'MON') {
        //   days = days === '' ? this.lang.MON : days+', '+this.lang.MON;
        // }
        // else if (order_days[i] == 'TUE') {
        //   days = days === '' ? this.lang.TUE : days+', '+this.lang.TUE;
        // }
        // else if (order_days[i] == 'WED') {
        //   days = days === '' ? this.lang.WED : days+', '+this.lang.WED;
        // }
        // else if (order_days[i] == 'THU') {
        //   days = days === '' ? this.lang.THU : days+', '+this.lang.THU;
        // }
        // else if (order_days[i] == 'FRI') {
        //   days = days === '' ? this.lang.FRI : days+', '+this.lang.FRI;
        // }
        // else if (order_days[i] == 'SAT') {
        //   days = days === '' ? this.lang.SAT : days+', '+this.lang.SAT;
        // }
        // else if (order_days[i] == 'SUN') {
        //   days = days === '' ? this.lang.SUN : days+', '+this.lang.SUN;
        // }
      }
    }
    return days;
  }

  cancelSubscription(action) {
    this.appService.appObject.isLoading = true;
    this.appService.cancelSubscription(this.subscription_id, action).then((response: any) => {
      if (response.status) {
        // console.log("esponse.status :", response.status);
        if(this.appService.isWebVersion){
          if(action == 'active' && this.orderInfo?.order_details?.payment_type == 'paypal' && response.url){
            this.handlePaypalReactive(response.url);
          }else{
            this.onPaymentCancel.emit(response);
          }

        }else{
          if(action == 'active' && this.orderInfo?.order_details?.payment_type == 'paypal' && response.url){
            this.handlePaypalReactive(response.url);
          }else{
            this.router.navigate(['my-orders'], {
              queryParams: {
                cancelSuscess: true
              }, replaceUrl: true
            });
          }
          
        }
      }
      this.appService.appObject.isLoading = false;
    }).catch((error) => {
      console.log('error : ', error);
      this.appService.appObject.isLoading = false;
    });
  }

  handlePaypalReactive(url){
    if(config.plf == 'web'){
       window.location = url;
    }else{
      const options: InAppBrowserOptions = {
        location: 'no',
        clearcache: 'yes',
        zoom: 'yes',
        toolbar: 'yes',
        closebuttoncaption: 'close'
      };
      //open in app
      const browser: any = this.iab.create(url, '_blank', options);
      //event subscribe
      browser.on('loadstop').subscribe(event => {
        //order status check
        this.RequestService.post('order/payment/status', { payment_id: this.subscriptionInfo.payment_id, device_id: this.appService.appObject.deviceUUID, lang: this.appService.appObject.currentLang, is_subscription_order: true }).then(paymentStatus => {
          if (paymentStatus.status && (paymentStatus.data.status === "paid" || paymentStatus.data.status === 'scheduled')) {
            setTimeout(() => {
              //payment done
              browser.close(); 
              this.router.navigate(['/subscription-summery/' + this.subscription_id]); 

            }, 3000);
          } else if (paymentStatus.status && paymentStatus.data.status === "cancelled") {
            setTimeout(() => {
              //payment cancelled
              browser.close();
              //err
              this.translate.get('key.payment_faild_msg').toPromise().then((response) => {
                this.appService.showAlert('error', '', response);
              });
            }, 3000);
          } else {
            //payment cancelled
            const navUrl = event.url;
            if (navUrl.includes('return')) {
              setTimeout(() => {
                // browser.close();
                this.appService.showAlert('error', 'status missing', paymentStatus.data.status);
                //err
                this.translate.get('key.payment_faild_msg').toPromise().then((response) => {
                  // this.showAlert('error', '', response);
                });
              }, 3000);
            }
          }
          this.appService.appObject.isLoading = false;
        });
      });
      //end
    }
  }

  async presentAlertConfirm(action) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.lang.are_you_sure + '.?',
      message: action === 'cancel' ? this.lang.are_you_sure_that_you_want_to_cancel_this_subscription_order : this.lang.are_you_sure_that_you_want_to_active_again_this_subscription_order + '.?',
      mode: 'ios',
      buttons: [
        {
          text: this.lang.cancel,
          role: 'cancel',
          cssClass: this.appService.appObject.theme[this.appService.themeConfigFor]?.primaryColor,
          handler: (blah) => {
          },
        },
        {
          text: this.lang.send,
          handler: () => {
            this.cancelSubscription(action);
          },
        },
      ],
    });
    await alert.present();
  }

  async pauseResumeConfirmAlert(action) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.lang.are_you_sure + '.?',
      message: action === 'paused' ? this.lang.are_you_sure_that_you_want_to_pause_this_subscription_order : this.lang.are_you_sure_that_you_want_to_resume_this_subscription_order + '.?',
      mode: 'ios',
      buttons: [
        {
          text: this.lang.cancel,
          role: 'cancel',
          handler: (blah) => {
          },
        },
        {
          text: this.lang.send,
          handler: () => {
            this.pauseResumeSubscription(action);
          },
        },
      ],
    });
    await alert.present();
  }

  /**
   * Pause or Resume subscription order
   * @param action 'paused' / 'true'
   */
  pauseResumeSubscription(action) {
    this.appService.appObject.isLoading = true;
    this.appService.pauseResumeSubscription(this.subscription_id, action).then((response: any) => {
      if (response.status) {
        this.appService.showToast(response.msg,'success');
        this.getSubscriptionDetails();
      }else{
        if(response.msg) this.appService.showToast(response.msg,'danger');
        else{
          this.appService.showToast(response.msg,'Unable to ' +(action === 'paused'?'Pause' : 'Resume')+' this subscription!');
        }
      }
      this.appService.appObject.isLoading = false;
    }).catch((error) => {
      console.log('error : ', error);
      this.appService.appObject.isLoading = false;
    });
  }

}
